import React from 'react';
import { AdminCrudShell, StatusBadge } from '@/components/admin/AdminCrudShell';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
];

export default function AdminRegions() {
  return (
    <AdminCrudShell
      title="Territorios y localizaciones"
      subtitle="País, comunidad autónoma o región, provincia y ciudad. Estas combinaciones alimentan los filtros públicos."
      entity="regions"
      testIdPrefix="admin-regions"
      searchPlaceholder="Buscar territorio…"
      initialForm={{ country: 'España', autonomous_community_or_region: '', province: '', city: '', status: 'active' }}
      columns={[
        { key: 'country', label: 'País', render: (r) => <span className="font-medium">{r.country}</span> },
        { key: 'autonomous_community_or_region', label: 'Comunidad / Región' },
        { key: 'province', label: 'Provincia' },
        { key: 'city', label: 'Ciudad' },
        { key: 'status', label: 'Estado', render: (r) => <StatusBadge status={r.status} /> },
      ]}
      formFields={[
        { name: 'country', label: 'País', required: true, placeholder: 'España' },
        { name: 'autonomous_community_or_region', label: 'Comunidad autónoma / Región', placeholder: 'Andalucía' },
        { name: 'province', label: 'Provincia', placeholder: 'Cádiz' },
        { name: 'city', label: 'Ciudad / Localidad', placeholder: 'San Fernando' },
        { name: 'status', label: 'Estado', type: 'select', required: true, options: STATUS_OPTIONS },
      ]}
    />
  );
}
